import { buildersSelector } from './buildersSelector';
import { sellersSelector } from './sellersSelector';
import { IApplicationState } from '../types/redux';
import { hasValidPhone, isLeadFactory } from '../utils/agent';

export const hasContactsSelector = (state: IApplicationState): boolean => {
  const builders = buildersSelector(state);
  const sellers = sellersSelector(state);

  /* oxlint-disable typescript/no-explicit-any */
  const buildersWithPhones = builders.filter(hasValidPhone as any);
  const sellersWithPhones = sellers.filter(hasValidPhone as any);
  const leadFactory = sellers.find(isLeadFactory);
  const contactsAmount = buildersWithPhones.length + sellersWithPhones.length;

  return Boolean(leadFactory || contactsAmount > 0);
};
